import {
  mapGetters,
  mapMutations,
} from 'vuex';

import europeanUnionIcon from '@/assets/images/icons/european-union.svg';

export default {
  name: 'LicensePlate',
  components: {
    europeanUnionIcon,
  },
  props: {},
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      licensePlateState: 'getLicensePlate',
    }),
    licensePlate: {
      get() {
        return this.licensePlateState;
      },
      set(value) {
        const clearedValue = value.replace(/[--]/g, '').replace(' ', '');
        this.setLicensePlateMutation(clearedValue);
      },
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setLicensePlateMutation: 'SET_LICENSEPLATE',
    }),
    updateLicensePlate() {
      this.setLicensePlateMutation(this.licensePlate);
    },
  },
};
